import { render, staticRenderFns } from "./BusinessOutcomePlans.vue?vue&type=template&id=4b064908&"
import script from "./BusinessOutcomePlans.vue?vue&type=script&lang=js&"
export * from "./BusinessOutcomePlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports